import s from './Toast.module.scss';
import {TToastProps} from "@/app/[locale]/common/components/Toast/types";
import ReactDOM from "react-dom";
import {useEffect, useState} from "react";

export const Toast = ({ title, description, Icon, isOpen }: TToastProps) => {
    const [ openToast, setOpenToast ] = useState<boolean>(isOpen);

    useEffect(() => {
        const timeout = setTimeout(() => {
            setOpenToast(false);
        }, 5000);

        return () => clearTimeout(timeout);
    }, []);

    if (!openToast) {
        return null;
    }

    const toastContent = (
        <div className={s.toast}>
            <label>
                <span>{<Icon/>}</span>
                {title}
            </label>
            <p>{description}</p>
        </div>
    )

    return ReactDOM.createPortal(toastContent, document.body);
};